import { render, staticRenderFns } from "./DashboardLoading.vue?vue&type=template&id=637552f3&scoped=true&"
import script from "./DashboardLoading.vue?vue&type=script&lang=js&"
export * from "./DashboardLoading.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLoading.vue?vue&type=style&index=0&id=637552f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637552f3",
  null
  
)

export default component.exports